import L from 'leaflet'

function parseTreeData (regionJson) {
    if (!regionJson) {
      return []
    }
    let regionMap = {}
    regionJson.forEach(region => {
      let regionData = region[Object.keys(region)[0]]
      let regionInfo =  {
        id: regionData.data.region_code,
        name: regionData.data.name,
        latlong: [regionData.data.lat, regionData.data.lon],
        geom: parseGeom(regionData.data.geom),
        parent: regionData.data.parent,
        primary_ind: regionData.data.primary_ind,
      };
      regionInfo.children = contructChildrenList(regionData)
      regionMap[regionInfo.id] = regionInfo
      regionMap = {...regionMap, ...parseTreeData(regionData.children)}
    });
    return regionMap
}

function contructChildrenList(region) {
  if (!region || !region.children) {
    return
  }
  let children = []
  region.children.forEach((child) => {
    let childData = child[Object.keys(child)[0]]
    children.push({
      id: childData.data.region_code,
      name: childData.data.name,
      children: contructChildrenList(childData)})
  });
  return children
}

function parseGeom(geom) {
  if (!geom) {
    return null
  }
  let geoJson = JSON.parse(geom)
  return [L.GeoJSON.coordsToLatLngs(geoJson[0])]
}

const regionModule = {
    state: {
        regions: {},
    },
    mutations: {
        setRegionData: (state, data) => {
            state.regions = parseTreeData(data)
        }
    },
    getters: {
        getRegion: (state) => (id) => {
          return state.regions[id]
        },
        getRegionTree: state => {
          return Object.values(state.regions).filter((region) => region.parent === '')
        },
        getAllRegionParents: state => {
          let parents = []
          Object.keys(state.regions).forEach((region_id) => {
            let parent = state.regions[region_id].parent
            if (!parent) {
              parents.push(region_id)
            } else {
              parents.push(`${parent}.${region_id}`)
            }
          })
          return parents
        }

    }
}

export default regionModule
